import { ChangeEvent, useEffect, useState } from 'react';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import { useHistory, useParams } from 'react-router-dom';
import { List } from 'immutable';
import { updateCallRouting } from 'flow/actions/call-routing-actions';
import Loading from 'flow/components/ui-components/Loading';
import Button from 'flow/components/ui-components/Button';
import InputField from 'flow/components/ui-components/InputField';
import useAppContext from 'flow/hooks/useAppContext';
import { BlocklistException } from 'flow/types/Callrouting';
import { BlockistParams } from 'flow/types/Params';
import { routes } from 'flow/types/routes';

import { TypedMap } from 'flow/types/TypedMap';
import { generatePath } from 'flow/utils/router-utils';
import Page from '../Page';

const EditCallRoutingExceptionAdd = () => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const history = useHistory();
    const { extensionKey, blocklistKey, type } = useParams<BlockistParams>();
    const callRouting = useAppSelector((state) =>
        state.callRoutings.getIn([type, blocklistKey]),
    );
    const [exceptionString, setExceptionString] = useState('');
    const defaultValue = callRouting?.get('matcher');

    useEffect(() => {
        setExceptionString(defaultValue.replace(/\*$/, ''));
    }, [defaultValue]);

    const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
        setExceptionString(event.target.value);
    };
    const trimmedDefaultValue = defaultValue.replace(/\*$/, '');

    const disabled = !(
        exceptionString.startsWith(trimmedDefaultValue) &&
        exceptionString.length > trimmedDefaultValue.length
    );

    const updateCallRoutingActionAndGoBack = (exceptionString: string) => {
        let updatedCallRoutingDTO;
        const prevExceptions = callRouting.get('blocklistExceptions', List());
        const alreadyExist = prevExceptions.some(
            (exception: TypedMap<BlocklistException>) =>
                exception.get('matcher') === exceptionString,
        );

        updatedCallRoutingDTO = callRouting.update(
            'blocklistExceptions',
            List(),
            (list: any) => {
                if (!alreadyExist) {
                    return list.push({
                        matcher: exceptionString,
                    });
                }
            },
        );

        dispatch(updateCallRouting(updatedCallRoutingDTO));

        history.push(
            generatePath(
                routes[
                    'settings.softphone.advanced.callrouting.type.blocklistKey'
                ],
                { extensionKey, type, blocklistKey },
            ),
        );
    };

    if (!callRouting) {
        return <Loading />;
    }

    return (
        <Page
            header={'settings.callrouting.exceptions.add'}
            onClickBack={() =>
                history.push(
                    generatePath(
                        routes[
                            'settings.softphone.advanced.callrouting.type.blocklistKey'
                        ],
                        { extensionKey, type, blocklistKey },
                    ),
                )
            }
        >
            <InputField
                label={i18next.t('settings.number')}
                value={exceptionString}
                onChange={handleInputChange}
                defaultValue={defaultValue}
            />

            <p className="p-2 text-xs text-gray-500">
                {i18next.t('settings.callrouting.exceptions.add.error')}
            </p>

            <p className="p-2 text-xs text-gray-500">
                {i18next.t('settings.callrouting.exceptions.helptext')}
            </p>

            <Button
                className="w-full border"
                color="ghost"
                onClick={() =>
                    updateCallRoutingActionAndGoBack(exceptionString)
                }
                disabled={disabled}
            >
                {i18next.t('settings.callrouting.exceptions.add')}
            </Button>
        </Page>
    );
};

export default EditCallRoutingExceptionAdd;
